import { ShoppingListModel } from '../../../../types/ShoppingList';
import { ShoppingListProductModel } from '../../../../types/ShoppingListProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import { getNowISO } from '../../../../utils/date';

export const prepareUpdateShoppingList = ({
    shoppingListElement,
    name,
    organisationID,
}: {
    shoppingListElement: ShoppingListModel;
    name: string;
    organisationID: string;
}) =>
    shoppingListElement.prepareUpdate((shoppingList) => {
        shoppingList.userId = shoppingListElement.userId;
        shoppingList.organisationId =
            shoppingListElement.organisationId || organisationID;
        shoppingList.name = name;
        shoppingList.addedToInventoryTime =
            shoppingListElement.addedToInventoryTime;
        shoppingList.sentToDealerTime = shoppingListElement.sentToDealerTime;
        shoppingList.dealerId = shoppingListElement.dealerId;
    });

export const prepareSendShoppingListToDealer = ({
    shoppingListElement,
    dealerId,
}: {
    shoppingListElement: ShoppingListModel;
    dealerId: string;
}) =>
    shoppingListElement.prepareUpdate((shoppingList) => {
        shoppingList.dealerId = dealerId;
        shoppingList.requestedSendingToDealerTime = getNowISO();
    });

export const prepareUpdateShoppingListName = ({
    shoppingListElement,
    name,
}: {
    shoppingListElement: ShoppingListModel;
    name: string;
}) =>
    shoppingListElement.prepareUpdate((shoppingList) => {
        shoppingList.name = name;
    });

export const logUpdateShoppingListActions = ({
    shoppingListElement,
    shoppingListProductsToAdd,
    shoppingListProductsToUpdate,
    shoppingListProductsToDelete,
    logDBAction,
    tableName,
}: {
    shoppingListElement: ShoppingListModel;
    shoppingListProductsToAdd: ShoppingListProductModel[];
    shoppingListProductsToUpdate: ShoppingListProductModel[];
    shoppingListProductsToDelete: ShoppingListProductModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Update shopping list',
        modelName: tableName,
        payload: shoppingListElement,
    });

    if (shoppingListProductsToAdd.length > 0) {
        logDBAction({
            message: 'Update shopping list - create shopping list products',
            modelName: tableName,
            payload: shoppingListProductsToAdd,
        });
    }

    if (shoppingListProductsToUpdate.length > 0) {
        logDBAction({
            message: 'Update shopping list - update shopping list products',
            modelName: tableName,
            payload: shoppingListProductsToUpdate,
        });
    }

    if (shoppingListProductsToDelete.length > 0) {
        logDBAction({
            message: 'Update shopping list - delete shopping list products',
            modelName: tableName,
            payload: shoppingListProductsToDelete,
        });
    }
};
